module.exports = __webpack_public_path__ + "static/media/inventory.dd2cc80c.svg";